define([], function() {
    return {
        POST: 'POST',
        PATH: 'PATH',
        QUERY: 'QUERY',
        OTHER: 'OTHER'
    };
});



// WEBPACK FOOTER //
// ./common/parameterApplications.js